<template>
  <div class="p-12 max-w-5xl mx-auto">
    <div class="space-y-16">
      <div class="flex items-center justify-between">
        <h4 class="text-indigo-500 capitalize">Forms</h4>
      </div>

      <BaseAdvancedList searchable :loading="pending" :entities="forms" :meta="meta">
        <template #header>
          <ListHeader />
        </template>

        <template #default="listProps">
          <ListItem :entity="listProps.entity" />
        </template>
      </BaseAdvancedList>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import ListHeader from '@/components/Forms/ListHeader.vue';
import ListItem from '@/components/Forms/ListItem.vue';

export default {
  components: {
    ListHeader,
    ListItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    pending: false,
  }),
  computed: {
    ...mapState('ui/accountForms', ['meta']),
    ...mapGetters('ui/accountForms', ['forms']),
  },
  watch: {
    $route: 'fetchData',
  },
  created() {
    this.fetchData();
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...mapActions('ui/accountForms', ['fetchAccountFormList']),
    ...mapMutations('ui/accountForms', ['setIds', 'setMeta', 'setLinks']),
    async fetchData() {
      const { accountId } = this;
      const { query: params } = this.$route;
      this.pending = true;
      try {
        await this.fetchAccountFormList({ accountId, params });
      } catch (error) {
        //
      }
      this.pending = false;
    },
  },
};
</script>
